import React, { useState } from 'react';
import { bool, shape, string } from 'prop-types';
import classNames from 'classnames';
import { Col } from '@thd-olt-component-react/grid';
import { Button } from '@thd-olt-component-react/button';
import { Overlay } from '@thd-olt-component-react/overlay';
import { Heading } from '@thd-olt-component-react/heading';
import { Image } from '@thd-olt-component-react/image';
import { useReviewsDeprecated, useProductDeprecated } from "@thd-nucleus/data-sources/react/dataModel/migration";
import { WriteAReviewForm } from './components/WriteAReviewForm/WriteAReviewForm';
import { usePresentation } from '../../context/PresentationProvider';
import { ReviewStatsModel } from '../models/ReviewStatsModel';
import { dataModel } from "../ReviewDataModel";
import * as analytics from '../../ratings-reviews-analytics';
import './WriteAReview.styles.scss';

export const WriteAReview = ({
  apiKey, className, itemId, link, reviewStatistics, totalReviews, triggerOverlay
}) => {
  const { useCondensedLayout } = usePresentation();
  const [overlayOpen, setOverlayOpen] = useState(!!triggerOverlay);
  const origin = link ? 'zone a' : 'ratings and reviews';
  const variables = {
    filters: {
      isVerifiedPurchase: false,
      prosCons: null,
      starRatings: null
    },
    searchTerm: null,
    sortBy: 'photoreview',
    startIndex: 1
  };
  const { data, error, loading } = useProductDeprecated({ itemId, domains: ['identifiers', 'media'] });
  const reviewResponse = useReviewsDeprecated({ itemId, variables }) || {};
  const nullProduct = (error && !data) || !data || loading;
  const nullReviews = (reviewResponse.error && !reviewResponse.data) || !reviewResponse.data || reviewResponse.loading;

  if (nullProduct || nullReviews) {
    return null;
  }

  const { reviews } = (reviewResponse || {}).data || {};
  const { product } = data || {};
  const reviewStats = reviewStatistics || new ReviewStatsModel(reviews);
  const { totalReviewCount, secondaryRatingsLabels = [] } = reviewStats;
  const linkClasses = classNames('u__default-link', className, 'write-review-content__button-link');
  const reviewsClass = classNames(className, {
    'write-review-content__submit__desktop__button': totalReviewCount,
    'write-review-content__submit__desktop__button-no-reviews': !totalReviewCount,
  });

  const buttonText = (totalReviewCount && totalReviewCount > 0) || (totalReviews > 0)
    ? 'Write a Review'
    : 'Write the First Review';

  const writeAReviewClick = () => {
    setOverlayOpen(true);
    analytics.track('event', {
      origin: 'ratings and reviews',
      location: 'zone a',
      value: 'write a review',
    });
  }

  return (
    <div className={!link ? "write-review-content__submit__desktop_content" : ''}>
      <Button outline className={link ? linkClasses : reviewsClass} onClick={writeAReviewClick} link={link}>
        {buttonText}
      </Button>
      {overlayOpen && (
        <Overlay onClose={() => setOverlayOpen(false)} open={overlayOpen}>
        {useCondensedLayout &&
        <>
        <Button link className="content-card__overlay-back content-card__overlay"  onClick={() => setOverlayOpen(false)}>
          <span>
            <Image
              className="content-card__overlay-caret"
              src="https://assets.homedepot-static.com/images/v1/back-arrow-orange.svg"
              alt="Back"
              lazy
            />
          </span>
          Back
        </Button>
        <Heading className="content-card__overlay-title" underline >{buttonText}</Heading>
        </>
      }
        <Col flatten className="content-card__overlay-content">
          <WriteAReviewForm
            apiKey={apiKey}
            closeOverlay={() => setOverlayOpen(false)}
            headerText={buttonText}
            itemId={itemId}
            product={product}
            reviewStatistics={reviewStats}
          />
          </Col>
        </Overlay>
      )}
    </div>
  );
};

WriteAReview.displayName = 'WriteAReview';

WriteAReview.propTypes = {
  apiKey: string.isRequired,
  className: string,
  itemId: string.isRequired,
  link: bool,
  reviewStatistics: shape({}),
  totalReviews: string
};

WriteAReview.defaultProps = {
  className: null,
  link: false,
  totalReviews: null
};

WriteAReview.dataModel = dataModel;
